import { render, staticRenderFns } from "./BookCover.vue?vue&type=template&id=5dcb0319"
import script from "./BookCover.vue?vue&type=script&lang=js"
export * from "./BookCover.vue?vue&type=script&lang=js"
import style0 from "./BookCover.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports